const DETAIL_RESULT_QUESTION = "/question/detail_question_exam";
const DETAIL_EXAM = "/exam/by_id";

export const result = {
  DETAIL_RESULT_QUESTION,
  DETAIL_EXAM,
};
